import React from 'react'
import { useParams } from "react-router";
import api from "../components/utils/api";
import { useState } from 'react';
import swal from 'sweetalert';
import { useEffect } from 'react';
import { formatDate } from '../components/utils/formatoFecha';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { stylesPdf, sectionTitle, th, td, tdAccent, divider } from "../components/utils/formatoPdf";
import './visorPdf.css';
import { obtenerHora } from '../components/utils/Funciones';

// Inicializar pdfMake una sola vez fuera del componente
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const VisorPdf = () => {
    const { idservicio } = useParams();
    const UrlServicios = api.urlAPI + "servicios/"+ idservicio ;
    const [loading, setLoading] = useState(false);
    const [servicio, setServicio] = useState([]);
    const userToken = localStorage.getItem("user-token");
    const ListarServicioPorID = async () => {
        
        try {
          const headers = { "iron-token": userToken };
          setLoading(true);
          let res = await fetch(UrlServicios, { headers });
          setLoading(false);
          if (res.ok) {
            let data = await res.json();
            generarPDF(data.data)
            setServicio(data.data);
          } else {
            setLoading(false);
            throw new Error(
              "No fue posible obtener los registros, vuelve a intentar más tarde."
            );
          }
        } catch (error) {
          setLoading(false);
          swal("Error", error.message, "error");
        }
      };
      useEffect(() => {
        ListarServicioPorID();
      
      }, []);
  

       //Genera pdf
  const generarPDF = (rowData) => {
    const imageUrl = require("../Img/IronLogo2.png");
    const tipoServicio =
      rowData.tipoServicioReparacion === "1" ? "Reparación"
      : rowData.tipoServicioServicio === "1"  ? "Servicio"
      : rowData.tipoServicioGarantia === "1"  ? "Garantía"
      : (rowData.tipoServicioOtros || "—");

    const repuestosRows = (rowData.repuestosPorServicios || []).map((r, i) => [
      td(r.cantidad, i % 2 === 1),
      td(r.codigo, i % 2 === 1),
      td(r.descripcion, i % 2 === 1),
    ]);
    const repuestosTable = repuestosRows.length > 0
      ? { style: "tableExample", table: { widths: [80, 130, "*"], headerRows: 1,
          body: [[th("Cantidad"), th("Código"), th("Descripción")], ...repuestosRows] },
          layout: "lightHorizontalLines" }
      : { text: "Sin repuestos registrados.", fontSize: 9, color: "#888", margin: [0,4,0,4] };

    const content = [
      { columns: [
          { stack: [
              { text: "Solicitud de servicio técnico", style: "mainTitle" },
              { text: tipoServicio, bold: true, fontSize: 9, color: "#1a0e00", background: "#ED9519", margin: [0,3,0,0] },
            ]},
          { stack: [
              { text: `# ${rowData.id}`, style: "formId", alignment: "right" },
              { text: formatDate(rowData.fecha), style: "formDate", alignment: "right" },
            ]},
        ], margin: [0,0,0,2] },
      divider(4, 10),
      sectionTitle("Información del cliente"),
      { style:"tableExample", layout:"lightHorizontalLines", table:{ widths:["*","*","*","*"], headerRows:1,
          body:[[th("Cliente"),th("Contacto"),th("Dirección"),th("Localidad")],
                [td(rowData.cliente),td(rowData.contacto,true),td(rowData.direccion),td(rowData.localidad,true)]] }},
      sectionTitle("Información de la máquina"),
      { style:"tableExample", layout:"lightHorizontalLines", table:{ widths:[100,100,100,"*"], headerRows:1,
          body:[[th("Modelo"),th("N° Chasis"),th("N° Motor"),th("Tipo de servicio")],
                [td(rowData.modelo),td(rowData.chasis,true),td(rowData.motor),tdAccent(tipoServicio)]] }},
      { style:"tableExample", layout:"lightHorizontalLines", margin:[0,2,0,0],
        table:{ widths:["*","*"], headerRows:1,
          body:[[th("Horómetro"),th("Hodómetro")],[td(rowData.horometro),td(rowData.hodometro,true)]] }},
      sectionTitle("Informe del técnico"),
      { style:"tableExample", layout:"lightHorizontalLines", table:{ widths:["*","*"], headerRows:1,
          body:[[th("Descripción de la falla"),th("Servicio realizado")],
                [tdAccent(rowData.descripcionFalla||"—"),
                 td(rowData.servicio||"—", true)]] }},
      sectionTitle("Repuestos utilizados"),
      repuestosTable,
      sectionTitle("Datos del técnico"),
      { style:"tableExample", layout:"lightHorizontalLines", table:{ widths:["*",80,90,90], headerRows:1,
          body:[[th("Técnico"),th("Km"),th("Hora inicio"),th("Hora fin")],
                [td(rowData.tecnico),td(rowData.kmRecorridos,true),td(obtenerHora(rowData.horaInicio)),td(obtenerHora(rowData.horaFin),true)]] }},
      sectionTitle("Limitación de responsabilidad", 14),
      { text:"IRON GROUP no responde por reparaciones hechas por fuentes no autorizadas, abuso, accidente, descuido, almacenamiento inapropiado ni uso de piezas no fabricadas o recomendadas por IRON GROUP.",
        style:"disclaimer", margin:[0,0,0,4] },
      sectionTitle("Conformidad del cliente", 14),
      { style:"tableExample", layout:"lightHorizontalLines", table:{ widths:["*","*","*","*"], headerRows:1,
          body:[[th("Firma cliente"),th("Aclaración — DNI"),th("Firma técnico"),th("Técnico")],
                [{ image:`${rowData.firmaCliente}`,width:90,height:50,alignment:"center",margin:[0,4,0,4]},
                 { text:`${rowData.aclaracionCliente||""}\nDNI: ${rowData.dni||""}`,fontSize:9,color:"#333",alignment:"center",margin:[4,10,4,4]},
                 { image:`${rowData.firmaTecnico}`,width:90,height:50,alignment:"center",margin:[0,4,0,4],fillColor:"#f5f5f5"},
                 { text:rowData.tecnico||"",fontSize:9,color:"#333",alignment:"center",margin:[4,10,4,4],fillColor:"#f5f5f5"}]] }},
    ];

    const documentDefinition = {
      pageMargins: [32, 80, 32, 50],
      header: () => ({
        margin: [32,16,32,0],
        stack: [
          { columns:[
              { image:imageUrl, width:150, style:"imagenLogo" },
              { stack:[
                  { text:"Km 26351, Colectora Este Panamericana 1611", style:"direccion", alignment:"right" },
                  { text:"B1611 Don Torcuato, Buenos Aires", style:"direccion", alignment:"right" },
                  { text:"postventa@iron-group.com  |  www.iron-group.com", style:"direccion", alignment:"right" },
              ]},
          ]},
          divider(6, 0, "#111111", 1.5),
        ],
      }),
      footer: (currentPage, pageCount) => ({
        margin:[32,8,32,0],
        columns:[
          { text:"Iron Group S.A.  ·  www.iron-group.com", fontSize:7, color:"#aaaaaa" },
          { text:`Página ${currentPage} de ${pageCount}`, fontSize:7, color:"#aaaaaa", alignment:"right" },
        ],
      }),
      content,
      styles: stylesPdf,
    };
 
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition);
    pdfDocGenerator.getDataUrl((dataUrl) => {
        const targetElement = document.querySelector('#iframeContainer');
        const iframe = document.createElement('iframe');
        iframe.src = dataUrl;
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.position = 'absolute';
        targetElement.appendChild(iframe);
       });
  };
  return (
    <div className='visor'>
        <div  id='iframeContainer'></div>
    </div>
    
  )
}

export default VisorPdf